<template>
  <div>
    <div class="backgroundGrey">
      <b-container class="newslist">
        <h2 class="heading">News Articles</h2>
        <b-row>
          <b-col
            lg="4"
            id="mobilePost"
            v-for="(posts, index) in SecondDatetime"
            :key="index"
            class="colsMargin"
          >
            <b-nav-item :to="'/news/' + posts.slug">
              <div class="overflowImage postsource" v-bind:style="{ 'background-image': 'url(' + posts.better_featured_image.source_url + ')' }">
              </div>
              <div class="FirstPostContentBlock">
                <p class="date">{{posts.PostnewDate}}</p>
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <div class="outerNews">
                  <div class="FullNews">
                    <b-link :to="'/news/' + posts.slug" class="allNewsLink">
                      <button class="Allbuttons">
                        Read More
                      </button>
                    </b-link>
                  </div>
                </div>
              </div>
              <div class=""></div>
            </b-nav-item>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
  
</template>

<script>
import apiCall from "@/services/api.js";
export default {
  name: "posts",
  props: ["config"],
  data() {
    return {
      posts: [],
      showAllnews: ''
    };
  },
  computed: {
    SecondDatetime: function() {
      let Allpost = this.posts
      console.log("Allpost")
      console.log(Allpost)
      // let arr = [];

      this.posts.forEach((value) => {
          var dateOG = value.date.split('T')
          var splitDate = dateOG[0].split('-')
          var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]        
          value.PostnewDate = newDate;
      });
      return Allpost
    },
    dateTime:function(){
      let arr = [];
      console.log("arr")
      console.log(arr)
      this.posts.forEach((value) => {
        var dateOG = value.date.split('T')
        var splitDate = dateOG[0].split('-')
        var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]
        this.posts.push(newDate);
      });
      return arr
    }
  },
  methods: {
    showMoreNews: function() {
      this.showAllnews = true;
    },
    showLessNews: function() {
      this.showAllnews = false;
    }
  },
  created() {
    const json = "wp/v2/posts?randomadd=" +
          new Date().getTime();
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.posts = data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
a.allNewsLink {
  text-decoration: none;
}
.overflowImage.postsource {
  background-repeat: no-repeat;
  height: 500px;
  background-size: cover;
  background-position: bottom;
}
.SeeMorebtn {
  margin: auto;
  text-align: center;
  display: block;
  padding-top: 50px;
  padding-bottom: 50px;
}
a.allNewsLink.router-link-exact-active.router-link-active {
  position: relative;
  top: -11px;
  text-decoration: none;
}
.outerNews {
  position: absolute; 
  left: 0;
  right: 0;
  bottom: 70px;
}
.colsMargin.col-lg-6 {
  padding-right: 0px;
  padding-left: 0px;
}
.overflowImageSecond.imageRight {
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
div#mobilePost {
  padding-bottom: 40px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
div#mobilePost:hover {
  transform: translateY(-10px);
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
li.nav-item.bottomLinks > a {
  padding-left: 0px;
  padding-right: 0px;
}
.whiteBK {
  /* padding-top: 30px; */
  padding-top: 100px;
}
.backgroundGrey {
  background-color: #F8F8F8;
  padding-bottom: 50px;
  padding-top: 60px;
}
.AllbuttonsSeeAll {
  width: 244px;
  height: 50px;
  background: transparent;
  color: #C8102E;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.AllbuttonsSeeAll:hover {
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
.Allbuttons {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: transparent;
  color: #C8102E;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  margin: auto;
  display: block;
}
.Allbuttons:hover {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  margin: auto;
  display: block;
}
.heading{
  font-weight: 600;
  font-size: 40px;
  color: #C8102E;
  padding-bottom: 50px;
}
.FirstPostContentBlock {
  border: 1px solid #E8E8E8;
  width: 100%;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 35px;
  height: 350px;
  background: #fff;
}
p.date {
  color: #C8112E;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
h1.postsTitle.LeftImage {
  font-weight: 600;
}
h1.postsTitle.rightTitles {
  font-size: 26px;
  padding-top: 40px;
}
h1.postsTitle.rightTitles > span {
  font-size: 26px;
}
img.imageRight.img-fluid.postImg {
  border-radius: 50px;
  max-width: 100%;
  height: 188px;
  width: auto;
  float: right;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  width: 100%;
}
span.postText {
  font-size: 12pt;
}
h1.postsTitle {
  font-size: 24px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #152229;
  font-weight: 600;
}
.overflowImage {
  overflow: hidden;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  max-height: 389px;
}
.overflowImageSecond {
  overflow: hidden;
  /* height: 278px; */
  border-radius: 6px;
  max-height: 425px;
}
#mobilePost:last-child {
  /* padding-right: 0px; */
}

.postRow {
  padding-bottom: 10px;
}
::v-deep .nav-link {
  color: black !important;
  width: 100%;
  text-align: left;
  padding: 0;
}
.moreNews>a{
  background-color: transparent;
  color: #C8102E!important;
}
#leftMore{
  color: #fff;
  background-color: #C8102E;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  padding: 3px;
}
@media only screen and (max-width: 1201px) {
  .FirstPostContentBlock {
    border: 1px solid #E8E8E8;
    width: 100%;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding: 35px;
    height: 400px;
    background: #fff;
  }
}
@media only screen and (max-width: 990px) {
  h1.postsTitle.rightTitles {
    font-size: 26px;
    padding-top: 15px!important;
  }
  .FirstPostContentBlock {
    height: 380px;
  }
  .whiteBK {
    padding-top: 30px;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #C8102E;
    font-weight: 500;
    border-radius: 50px;
    border: 1px solid #E8E8E8;
    margin: auto;
    margin-top: 30px;
    text-align: center;
    display: block;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 50px;
    border: 1px solid #E8E8E8;
    display: block;
    transform: translateY(-10px);
  }
  .heading{
    font-weight: 600;
    font-size: 40px;
    color: #C8102E;
    text-align: center;
  }
}
@media only screen and (max-width: 480px) {
  ::v-deep .nav-link {
    width: 100%;
  }
  #mobilePost {
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media only screen and (max-width: 1165px) {
  #mobilePost:last-child {
    padding-right: 15px;
    margin-top: 2em;
  }
  div#mobilePost {
    margin-top: 1em;
  }
}
</style>
